<div class="action-dropdown-outer">
    <ng-content></ng-content>
</div>